import { Pages } from "@/pages/constants"

export enum SessionNames {
  SEARCH = "search",
}

export type PageSessionType = {
  onStart: SessionNames[]
  onLeave: SessionNames[]
}

type EventSessionType = {
  [key: string]: PageSessionType
}

export const EVENTSESSIONS: EventSessionType = {
  [Pages.ReceiptList]: { onStart: [SessionNames.SEARCH], onLeave: [] },
  [Pages.ReceiptDetails]: {
    onStart: [SessionNames.SEARCH],
    onLeave: [SessionNames.SEARCH],
  },
}
